import {DtoModel} from '../../../../../../common/entity/dto/dto.model';
import {LovValueSummary} from '../../../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class CommunicationConfigurationEmailModel implements DtoModel {
    content: string;
    subject: string;
}
